
import CommonApi from '../commonApi';


const basedUrl = 'fuelAndOilMechanism';
const fuelAndOilMechanism = new CommonApi(
  basedUrl,
  'расчет гсм топливо, средства малой механизации'
);

export default {
  ...fuelAndOilMechanism
};
